import React, { useEffect } from "react";
import { motion } from "framer-motion";
import PageHeader from "../components/sections/PageHeader";
import Header from "../components/Header";
import Footer from "../components/Footer";
import CallToActionTitle from "../components/sections/CallToActionTitle";
import MagentButton from "../components/elements/MagnetButton";

const NotFoundPage = () => {
  const cardVariantsScaled = {
    offscreen: {
      y: -20,
      opacity: 0,
    },
    onscreen: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        bounce: 0.6,
        duration: 1.4,
        delay: 0.2,
      },
    },
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <motion.div initial={{ opacity: 0, y: -20 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -20 }} transition={{ duration: 0.5 }}>
      <Header showLogo={true} />

      <div className="relative">
        <PageHeader title={"Page Not Found"} imageName={"outdoor-tree-sunlight"} titleSmaller={false} />
        <div className="absolute top-0 right-0 bottom-0 left-0 h-full w-full overflow-hidden bg-[hsla(0,0%,0%,0.55)] bg-fixed"></div>
      </div>

      <div className="flex flex-col justify-center items-center bg-center bg-no-repeat bg-cover w-full mb-24 py-12">
        <h5 className="min-h-[300px] flex items-center justify-center text-2xl font-thin max-w-[580px] text-center uppercase text-primary-100">
          Page Missing its Daily Dose! The requested page may need an extra vitamin boost. Redirect to our homepage for a healthy dose of wellness and
          supplement options.
        </h5>

        {/*                            */}
        {/* 🟩 Quote                   */}
        {/*                            */}
        <div className="flex h-full items-center justify-center">
          <div className="px-6 text-center text-white md:px-12">
            <MagentButton title={"REFRESH"} colorCode={"#03a15e"} linkAddress={"/"} isLarge={true} />
          </div>
        </div>
      </div>

      <div
        className="relative overflow-hidden bg-cover bg-no-repeat bg-[50%] h-[500px]"
        style={{ backgroundImage: `url(/images/line-piles-colorful-spices.jpg)` }}
      >
        <div className="absolute top-0 right-0 bottom-0 left-0 h-full w-full overflow-hidden bg-[hsla(0,0%,0%,0.55)] bg-fixed">
          <div className="flex h-full items-center justify-center">
            <div className="px-6 text-center text-white md:px-12">
              <div className="max-w-[680px]">
                <CallToActionTitle />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/*                            */}
      {/* 🟩 Footer                  */}
      {/*                            */}
      <motion.div
        initial="offscreen"
        whileInView="onscreen"
        viewport={{ once: true, amount: 0.8 }}
        variants={cardVariantsScaled}
        className="flex justify-center items-center bg-center bg-no-repeat bg-cover"
        style={{
          backgroundImage: `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1920 1080"><g transform=" rotate(194 960 540) translate(-384.36393238172263 -216.20471196471897) scale(1.400379096230961) "><rect width="1920" height="1080" fill="rgb(252, 102, 1)"></rect><g transform="translate(0, 0)"><path fill="rgb(253, 114, 21)" fill-opacity="1" d="M0,264.707L64,262.556C128,260.405,256,256.103,384,255.436C512,254.769,640,257.737,768,258.071C896,258.405,1024,256.104,1152,227.387C1280,198.67,1408,143.537,1536,138.881C1664,134.225,1792,180.045,1856,202.956L1920,225.866L1920,1080L1856,1080C1792,1080,1664,1080,1536,1080C1408,1080,1280,1080,1152,1080C1024,1080,896,1080,768,1080C640,1080,512,1080,384,1080C256,1080,128,1080,64,1080L0,1080Z"></path></g><g transform="translate(0, 270)"><path fill="rgb(254, 126, 40)" fill-opacity="1" d="M0,4.145L64,36.907C128,69.669,256,135.193,384,151.514C512,167.835,640,134.953,768,104.517C896,74.081,1024,46.091,1152,60.539C1280,74.987,1408,131.872,1536,142.129C1664,152.386,1792,116.015,1856,97.83L1920,79.644L1920,810L1856,810C1792,810,1664,810,1536,810C1408,810,1280,810,1152,810C1024,810,896,810,768,810C640,810,512,810,384,810C256,810,128,810,64,810L0,810Z"></path></g><g transform="translate(0, 540)"><path fill="rgb(254, 138, 60)" fill-opacity="1" d="M0,79.529L64,105.937C128,132.344,256,185.158,384,213.523C512,241.888,640,245.804,768,213.506C896,181.208,1024,112.697,1152,84.467C1280,56.237,1408,68.289,1536,94.704C1664,121.12,1792,161.899,1856,182.289L1920,202.679L1920,540L1856,540C1792,540,1664,540,1536,540C1408,540,1280,540,1152,540C1024,540,896,540,768,540C640,540,512,540,384,540C256,540,128,540,64,540L0,540Z"></path></g><g transform="translate(0, 810)"><path fill="rgb(255, 150, 79)" fill-opacity="1" d="M0,253.429L64,233.844C128,214.259,256,175.089,384,135.235C512,95.38,640,54.842,768,32.523C896,10.205,1024,6.106,1152,30.809C1280,55.513,1408,109.018,1536,125.837C1664,142.655,1792,122.785,1856,112.85L1920,102.916L1920,270L1856,270C1792,270,1664,270,1536,270C1408,270,1280,270,1152,270C1024,270,896,270,768,270C640,270,512,270,384,270C256,270,128,270,64,270L0,270Z"></path></g></g></svg>')`,
        }}
      >
        <Footer />
      </motion.div>
    </motion.div>
  );
};

export default NotFoundPage;
